import {ngAsync} from 'shared/utils/ng-@decorators';
import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class SearchDataService {
    public static serviceName = 'searchDataService';
    public static readonly ROUTE = 'search';
    private readonly EXPORTS_PARAM = 'portaroSearchItemParagraph,portaroSearchItemMoreParagraph';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async search<T>(params: SearchParams): Promise<ViewableSearch<SearchParams, T>> {

        const defaultParams = {exports: this.EXPORTS_PARAM}

        return this.ajaxService
            .createRequest(SearchDataService.ROUTE)
            .get({...defaultParams, ...params})
    }
}